import { useTranslation } from 'react-i18next';
import { PostModal, PostModalProps } from '../shared';
import { Template, TemplatePostDetailsType, TemplateProps } from './template';

export type InfluencerYoutubeAnalyticsPostDetailsModalProps = Pick<TemplateProps, 'isAnalytics'> &
  Pick<PostModalProps<TemplatePostDetailsType>, 'posts' | 'paramKey'>;

export const InfluencerYoutubeAnalyticsPostDetailsModal = ({
  posts,
  paramKey,
  ...templateProps
}: InfluencerYoutubeAnalyticsPostDetailsModalProps) => {
  const { t } = useTranslation();

  return (
    <PostModal posts={posts} paramKey={paramKey}>
      <PostModal.Title>{t('Post Detail')}</PostModal.Title>
      <Template {...templateProps} />
    </PostModal>
  );
};
